var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 32,
    viewBox: "0 0 184 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1061_7721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1748 24.2113L61.7453 4.27905L65.517 4.2899L57.9466 24.2221L54.1748 24.2113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.115 12.0405C81.9207 11.0045 81.4027 10.2181 80.5717 9.68655C79.7354 9.15503 78.6508 8.88384 77.318 8.87842C75.9852 8.87842 74.7172 9.12249 73.5139 9.62689C72.8556 9.9035 72.2405 10.2669 71.6631 10.7171L72.2944 9.04113L68.8411 9.03028L63.089 24.2384L66.7151 24.2493L69.7314 16.3632C70.3033 14.8825 71.0858 13.7815 72.084 13.0601C73.0822 12.3388 74.2478 11.9808 75.5805 11.9862C76.8594 11.9862 77.6795 12.3388 78.0411 13.033C78.4026 13.7272 78.3486 14.6927 77.8792 15.9238L74.728 24.2655L78.354 24.2764L81.5484 15.8479C82.1204 14.351 82.3092 13.0818 82.115 12.0459V12.0405Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0104 27.0699C80.7065 27.0699 81.2893 26.8801 81.7533 26.4896C82.2173 26.0991 82.622 25.4808 82.9674 24.6238L88.8705 9.07399L92.4965 9.08484L86.6042 24.575C85.2283 28.1981 82.8595 30.0096 79.4924 30.0042C78.7748 30.0042 78.1327 29.9282 77.5553 29.7872C77.3449 29.733 77.1452 29.6733 76.9564 29.5974L77.8898 26.9235C77.8898 26.9235 79.1903 27.0699 80.005 27.0699H80.0104ZM91.9192 6.57365C91.2609 6.57365 90.7698 6.3784 90.4407 5.98789C90.1115 5.59738 89.9982 5.12551 90.0954 4.57772C90.2087 3.93229 90.5324 3.38992 91.0612 2.95602C91.59 2.52212 92.2267 2.30518 92.9606 2.30518C93.5973 2.30518 94.0883 2.49501 94.4283 2.86382C94.7682 3.23263 94.8923 3.68823 94.8006 4.21975C94.6765 4.92484 94.3527 5.49433 93.8347 5.92823C93.3113 6.36212 92.6746 6.57907 91.9192 6.57907V6.57365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5307 24.3034L97.2827 9.09523L100.909 9.10608L95.1567 24.3142L91.5307 24.3034ZM100.364 6.59489C99.7055 6.59489 99.2144 6.39964 98.8853 6.00913C98.5561 5.61862 98.4428 5.14675 98.54 4.59896C98.6533 3.95353 98.977 3.41116 99.5058 2.97726C100.035 2.54337 100.671 2.32642 101.405 2.32642C102.042 2.32642 102.533 2.51625 102.873 2.88506C103.213 3.25387 103.337 3.70947 103.245 4.24099C103.121 4.94608 102.797 5.51557 102.279 5.94947C101.756 6.38337 101.119 6.60031 100.364 6.60031V6.59489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8 15.9131C35.996 15.9131 35.2514 16.3904 34.9223 17.1226L33.3467 20.6588C33.0229 21.3911 32.2783 21.8683 31.4689 21.8683L2.40121 21.8521L3.33786e-05 27.8073L29.3537 27.8236C30.1793 27.8236 30.9401 27.3192 31.2477 26.5653L32.6614 23.1483C32.9743 22.3944 33.7298 21.89 34.5553 21.89H41.0574L43.4748 15.9131H36.8Z",
    fill: "url(#paint0_linear_1061_7721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6574 18.8634C29.483 18.8634 30.2438 18.359 30.5513 17.6051L31.9651 14.1882C32.278 13.4343 33.0335 12.9299 33.859 12.9299L44.6778 12.9407L47.0952 6.95836L36.1037 6.94751C35.2997 6.94751 34.5551 7.4248 34.2259 8.157L32.6503 11.6933C32.3266 12.4255 31.582 12.9028 30.7726 12.9028L6.02161 12.8865L3.61504 18.8472L28.652 18.8634H28.6574Z",
    fill: "url(#paint1_linear_1061_7721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0642 9.93609C29.2135 9.93609 30.2711 9.2527 30.7352 8.21677L32.6345 3.95372L9.6426 3.94287L7.22524 9.92524L28.0642 9.93609Z",
    fill: "url(#paint2_linear_1061_7721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.161 25.0161L108.838 6.80547L111.516 6.81205L115.453 23.6178L113.841 23.6138L124.698 6.84442L127.402 6.85106L115.709 25.0224L113.161 25.0161ZM131.237 25.2165C129.885 25.2132 128.715 24.9677 127.729 24.4799C126.742 23.9748 125.981 23.2796 125.446 22.3943C124.911 21.4917 124.644 20.4337 124.647 19.2203C124.651 17.6603 124.993 16.2745 125.672 15.0628C126.35 13.8512 127.271 12.9001 128.434 12.2096C129.615 11.5018 130.95 11.1498 132.441 11.1535C133.689 11.1565 134.772 11.4018 135.689 11.8894C136.607 12.3597 137.316 13.0374 137.816 13.9227C138.334 14.8079 138.592 15.8746 138.589 17.1226C138.588 17.4346 138.57 17.7552 138.534 18.0844C138.499 18.3964 138.455 18.6909 138.402 18.9681L126.468 18.9388L126.785 17.1196L137.21 17.1452L136.195 17.7667C136.353 16.7964 136.286 15.9816 135.993 15.3222C135.7 14.6455 135.233 14.133 134.593 13.7847C133.97 13.4192 133.216 13.2354 132.332 13.2332C131.292 13.2306 130.373 13.4797 129.574 13.9804C128.793 14.4638 128.185 15.147 127.749 16.0299C127.314 16.8955 127.095 17.9177 127.092 19.0963C127.089 20.3443 127.442 21.3159 128.151 22.011C128.877 22.6887 129.977 23.0294 131.45 23.0331C132.317 23.0352 133.123 22.8985 133.869 22.623C134.615 22.3302 135.231 21.9417 135.718 21.4575L136.78 23.2541C136.119 23.8939 135.295 24.3858 134.306 24.7301C133.317 25.057 132.294 25.2191 131.237 25.2165ZM140.554 25.0834L143.317 11.3102L145.709 11.316L144.919 15.3181L144.662 14.3295C145.306 13.1697 146.123 12.3571 147.112 11.8915C148.101 11.4259 149.324 11.1949 150.78 11.1985L150.306 13.6153C150.202 13.5978 150.098 13.5888 149.994 13.5886C149.89 13.5883 149.777 13.588 149.656 13.5877C148.286 13.5844 147.15 13.9543 146.247 14.6974C145.361 15.4405 144.76 16.6091 144.444 18.203L143.05 25.0896L140.554 25.0834ZM151.04 25.1092L153.804 11.3359L156.3 11.3421L153.536 25.1153L151.04 25.1092ZM155.786 8.68878C155.318 8.68763 154.937 8.53937 154.643 8.24398C154.366 7.94863 154.229 7.59296 154.23 7.17696C154.231 6.69162 154.396 6.2847 154.727 5.95617C155.057 5.61032 155.491 5.43805 156.028 5.43937C156.479 5.44048 156.851 5.58872 157.145 5.88411C157.456 6.16221 157.611 6.50059 157.61 6.89926C157.609 7.43659 157.443 7.86952 157.113 8.19804C156.783 8.52657 156.341 8.69015 155.786 8.68878ZM158.64 25.1278L161.718 10.0554C161.999 8.66938 162.565 7.5961 163.416 6.83552C164.285 6.07498 165.421 5.69644 166.825 5.69989C167.397 5.70129 167.934 5.78061 168.436 5.93785C168.956 6.07779 169.38 6.28683 169.709 6.56497L168.664 8.40841C168.18 7.97389 167.565 7.75571 166.82 7.75388C166.075 7.75205 165.476 7.95858 165.024 8.37347C164.59 8.78841 164.285 9.42033 164.11 10.2692L163.716 12.0623L163.583 13.1019L161.136 25.134L158.64 25.1278ZM158.668 13.4019L159.063 11.3488L167.877 11.3705L167.456 13.4235L158.668 13.4019ZM167.501 30.3496C166.842 30.348 166.193 30.2337 165.552 30.0068C164.911 29.7973 164.409 29.5014 164.046 29.1191L165.35 27.2763C165.644 27.5717 165.991 27.7979 166.389 27.9549C166.77 28.1292 167.203 28.2169 167.688 28.2181C168.26 28.2195 168.772 28.0647 169.223 27.7538C169.692 27.4603 170.17 26.9328 170.657 26.1714L171.962 24.1726L172.249 23.8873L180.157 11.4006L182.679 11.4068L172.866 26.6708C172.257 27.6053 171.683 28.3406 171.145 28.8766C170.606 29.4126 170.042 29.7925 169.452 30.0164C168.879 30.2403 168.229 30.3514 167.501 30.3496ZM171.491 25.6014L168.067 11.371L170.563 11.3771L173.471 23.6563L171.491 25.6014Z",
    fill: "#FF5300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1061_7721",
    x1: 30.6364,
    y1: 21.4665,
    x2: 19.3707,
    y2: 24.1595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B03AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C5363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F04B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1061_7721",
    x1: 27.8803,
    y1: 13.3954,
    x2: 16.5435,
    y2: 16.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B03AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C5363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F04B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1061_7721",
    x1: 32.2508,
    y1: 13.2611,
    x2: -3.70666,
    y2: -5.0915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B03AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C5363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F04B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1061_7721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.53fbc3e54041c006e91d0bc9aac9cc7f.svg";
export { ForwardRef as ReactComponent };